import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

const NextLevelModal = ({
  companyId,
  level,
  loading,
  open,
  refresh,
  setLoading,
  setOpen,
  unlockLevel,
}) => {
  const snackbar = useSnackbar()

  const handleUpdate = async () => {
    try {
      setLoading(true)

      const conformityLevel = unlockLevel ? level : level + 1

      await service.dponet.companies.updateComplianceLevel({
        companyId,
        company: { conformityLevel },
      })

      snackbar.open({
        message: 'Nível de conformidade atualizado com sucesso!',
        variant: 'success',
      })

      refresh()
      setOpen(false)
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      actionButtonText="Avançar"
      actionButton={handleUpdate}
      closeButtonText="Cancelar"
      dialogSize="sm"
      fullWidth
      justifyActions="end"
      loading={loading}
      open={open}
      setOpen={setOpen}
      title={unlockLevel ? 'Atenção!' : 'Parabéns'}
    >
      <Box py={2} component="form" textAlign="justify">
        {unlockLevel ? (
          <>
            <Typography gutterBottom>
              Ao atualizar os questionários para o próximo nível, estaremos
              implementando novas medidas de segurança para garantir um maior
              nível de conformidade para sua organização. É importante ressaltar
              que uma vez feita a atualização, não será possível retornar ao
              nível anterior.
            </Typography>
            <Typography variant="h6">
              Gostaria de aumentar seu nível?
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              Você concluiu o nível {level} de conformidade.
            </Typography>
            <Typography>
              Desbloqueie o nível {level + 1} do questionário para avançar e
              aumentar a conformidade da sua organização. Com isso, você
              implementará mais medidas de segurança, tornando sua empresa ainda
              mais protegida.
            </Typography>
          </>
        )}
      </Box>
    </BaseDialog>
  )
}

NextLevelModal.propTypes = {
  consentForm: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default NextLevelModal
